<div class="flex flex-column justify-content-center align-items-center w-full md:px-8 pb-3">
    <img src="/assets/images/features/Features2-400.webp" alt="Text Alert" class="max-h-18rem">
    <h2 class="text-center">SMS Notifications is a Premium+ Feature</h2>
    <span class="text text-center">We'll text you when we find a flight to one of your dream destinations so you never miss your dream deal.</span>
    <div class="w-full grid mt-4">
    <div class="col-12 py-2">
        <p-button
          label="Learn More"
          styleClass="learn-btn w-full"
          severity="info"
          (click)="upgrade()"
        ></p-button>
    </div>
        </div>
</div>
